import api from '../api'

import {
  fetchCreateDispositivoStart,
  fetchCreateDispositivoSuccess
} from '../reducers/endpoints/createDispositivo'
import {take, put, call} from 'redux-saga/effects'

export function* fetchCreateDispositivo(mss) {
  const url = `/dispositivo/create`

  //const userToken = localStorage.getItem('token')

  const headerParams = {
    headers: {
  //    Authorization: `Bearer ${ userToken }`
    }
  }
  console.log(mss)
  const values = mss.data
  try {
    console.log('********')
    const {data: geo} = yield call([api, 'post'], url, values, headerParams)
    console.log('USER VALIDATION ***************',geo)
    yield put(fetchCreateDispositivoSuccess({success: true}))
  } catch (error) {
    console.log('----', error)
    yield put(fetchCreateDispositivoSuccess({success: false}))
  }
}

export function* watchFetchCreateDispositivo() {
  while (true) {
    const {
      payload: mss
    } = yield take(fetchCreateDispositivoStart)
    yield call(fetchCreateDispositivo, mss)
  }
}